import {
    SEASONALITY_REQUEST,
    SEASONALITY_SUCCESS,
    SEASONALITY_FAILURE
} from '../../actions/marketInsights/seasonalityActions';

interface Seasonality {
    data: any;
    isFetching: boolean;
}

const fetchSeasonalityReducer = (seasonalityData: Seasonality = {
    isFetching: false,
    data: []
}, action: any): Seasonality => {
    switch (action.type) {
        case SEASONALITY_REQUEST: {
            return {
                ...seasonalityData,
                isFetching: true
            };
        }
        case SEASONALITY_SUCCESS: {
            return {
                ...seasonalityData,
                isFetching: false,
                data: action.payload
            };
        }
        case SEASONALITY_FAILURE: {
            return {
                ...seasonalityData,
                isFetching: false,
                data: []
            };
        }
        default:
            return seasonalityData;
    }
};

export default fetchSeasonalityReducer;
